import React, { useState } from 'react';

import { Button, Modal } from '@components/common';
import {
	TLinkCrowdCellFormSubmitHandler,
} from '@components/routes/AdminPanel/SiteProfile/LimenetProfile/LinkCrowdCellForm/LinkCrowdCellForm';

import { useMutateLinkCrowdCell } from '@hooks/crowdCells/useMutateLinkCrowdCell';

import { ISiteProfile } from '@interfaces/cells/siteProfile';

import { MODAL_WIDTH_455 } from '@constants/modals';

import LimenetTechnologyTable from './LimenetTechnologyTable';
import LinkCrowdCellForm from './LinkCrowdCellForm';
import LinkedCrowdCellInfo from './LinkedCrowdCellInfo';

import styles from './LimenetProfile.module.scss';

interface ILimenetProfileProps {
	profile: ISiteProfile;
	isEditAccess: boolean;
}

const LimenetProfile = ({ profile, isEditAccess }: ILimenetProfileProps) => {
	const { id, crowdCell } = profile;

	const [isShownLinkCrowdCell, setIsShownLinkCrowdCell] = useState(false);

	const openLinkCrowdCell = () => setIsShownLinkCrowdCell(prevState => !prevState);

	const closeLinkModal = () => setIsShownLinkCrowdCell(false);

	const { handleLinkCrowdCell } = useMutateLinkCrowdCell([closeLinkModal]);

	const linkCrowdCellHandler = (crowdCellId: string) => handleLinkCrowdCell({ siteDbId: id, crowdCellId });

	return (
		<div className={styles.limenetProfileContainer}>
			<Modal
				isOpen={isShownLinkCrowdCell}
				onClose={closeLinkModal}
				title='Link Flex-5G'
				width={MODAL_WIDTH_455}
			>
				<LinkCrowdCellForm
					closeModal={closeLinkModal}
					isLoadingRelinkForm={false}
					submitHandler={linkCrowdCellHandler as TLinkCrowdCellFormSubmitHandler}
					toggleLinkModal={closeLinkModal}
				/>
			</Modal>

			{!crowdCell ? (
				<>
					<Button
						disabled={!isEditAccess}
						large
						onClick={openLinkCrowdCell}
						text='Link Flex-5G'
					/>
					<div className={styles.content}>
						<span>Please link Flex-5G to get data</span>
					</div>
				</>
			) : (
				<>
					<div>
						<LinkedCrowdCellInfo
							crowdCell={crowdCell}
							isEditAccess={isEditAccess}
							siteDbId={id}
						/>
					</div>
					{crowdCell?.id
						? <LimenetTechnologyTable
							crowdCellId={crowdCell.id}
							isEditAccess={isEditAccess}
						/>
						: null}
				</>
			)}
		</div>
	);
};

export default LimenetProfile;
